import React from "react";
import { Progress, Skeleton, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { simpleKFormatterOnly } from "../../../redux/constants";

const AggregateCard = ({
  data,
  datatype,
  filter,
  id,
  split,
  isdownload,
  splitcolumncount,
}) => {
  //small aggregate cards placed on all 4 sides of sentiment aggregate card
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);

  //It formats big numbers by applying K

  return (
    <div
      className={`portlet_New ${split !== "split" ? "h-50-15" : ""}  mr-15 ${
        isdownload === true && splitcolumncount === 3 ? "mb-10" : "mb-15"
      }`}
    >
      <div className="w-100">
        {!data ? (
          <Skeleton active size="small" paragraph={{ rows: 1 }} />
        ) : (
          <>
            <div
              className="portlet__title font-size14 font-weight500 mb-0"
              style={{ lineHeight: "1.5rem" }}
            >
              {/* <Tooltip placement="rightTop" title={"abc"} arrowPointAtCenter={true}> */}
              {data?.title}
              {/* <span className="info_on_hover">*</span>
					</Tooltip> */}
            </div>
            <div className="row">
              <div className="col-8 d-flex align-items-end">
                <div
                  className="portlet__content font-weight600"
                  style={{ lineHeight: "normal" }}
                >
                  {((["list", "int"].includes(datatype) || filter > 0) &&
                    id !== 1 &&
                    id !== 2 &&
                    id !== 3) ||
                  id === 6 ? (
                    <>
                      {" "}
                      <Tooltip
                        title={`${data?.count.specific?.toLocaleString()} / ${data?.count.total?.toLocaleString()}`}
                      >
                        <span className="font-size24">
                          {simpleKFormatterOnly(data?.count.specific)}
                        </span>
                        <span className="font-size16 text-gray">
                          /{simpleKFormatterOnly(data?.count.total)}{" "}
                        </span>
                      </Tooltip>
                    </>
                  ) : (
                    <Tooltip title={data?.count?.toLocaleString()}>
                      <span className="font-size24">
                        {simpleKFormatterOnly(data?.count)}
                      </span>
                    </Tooltip>
                  )}
                </div>
              </div>
              <div
                className="col-4 text-right"
                style={
                  isdownload === true && splitcolumncount === 3
                    ? {}
                    : { minHeight: "5rem" }
                }
              >
                {((["list", "int"].includes(datatype) || filter > 0) &&
                  id !== 1 &&
                  id !== 2 &&
                  id !== 3) ||
                  (id === 6 && (
                    <Progress
                      trailColor="#B9CEF5"
                      strokeWidth={10}
                      format={(percent) =>
                        percent === 100 ? "100%" : `${percent}%`
                      }
                      strokeColor={{ "0%": "#185EDF" }}
                      width="5rem"
                      height="5rem"
                      type="circle"
                      percent={data?.count.percentage}
                    />
                  ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AggregateCard;
